// Mock data for CRS Tech website - STARTUP VERSION

export const companyInfo = {
  name: "CRS Tech",
  tagline: "Transforming Ideas Into Digital Excellence",
  mission: "As an emerging IT solutions provider, we're building a future where businesses find all their technology needs under one innovative roof. Our vision is to become the ultimate one-stop solution, eliminating the need for multiple vendors.",
  description: "CRS Tech is your trusted IT partner, specializing in cutting-edge web solutions. Founded by experienced professionals who've worked with leading companies, we bring enterprise-level expertise to every project - from initial concept to ongoing success.",
  email: "crstech.com.au@gmail.com",
  phone: "0415365783",
  established: "2024",
  teamSize: "2",
  focusAreas: "Web Development, Hosting, SEO"
};

export const teamMembers = [
  {
    id: 1,
    name: "Premanshu Savalia",
    position: "Founder & Front-end Developer",
    photo: "/api/placeholder/300/300",
    degrees: [
      "B.Sc. IT in Software Development - Gujarat University",
      "Master of IT in Enterprise Management - UNISA",
      "Master of IT (Extension) - Kaplan Business School"
    ],
    experience: "Previously worked at leading tech companies"
  },
  {
    id: 2,
    name: "Jay Khimusriya",
    position: "Back-end Developer",
    photo: "/api/placeholder/300/300",
    degrees: [
      "B.Sc. IT in Software Development - Gujarat University",
      "M.Sc. IT in Software Development - Gujarat University"
    ],
    experience: "Experienced in enterprise software development"
  }
];

export const services = [
  {
    id: 1,
    title: "Website Design",
    description: "Stunning, user-centric designs that captivate your audience and reflect your brand identity with pixel-perfect precision.",
    icon: "Palette",
    status: "active"
  },
  {
    id: 2,
    title: "Website Development",
    description: "Robust, scalable web applications built with cutting-edge technologies, ensuring optimal performance and seamless functionality.",
    icon: "Code",
    status: "active"
  },
  {
    id: 3,
    title: "Web Hosting",
    description: "Reliable, high-performance hosting solutions with 99.9% uptime guarantee, ensuring your website is always accessible.",
    icon: "Server",
    status: "active"
  },
  {
    id: 4,
    title: "Website Maintenance & SEO",
    description: "Continuous support, updates, and SEO management to keep your website secure, fast, highly ranked, and running smoothly.",
    icon: "Wrench",
    status: "active"
  },
  {
    id: 5,
    title: "Social Media Marketing",
    description: "Strategic social media campaigns to boost your brand visibility, engage your audience, and drive business growth across all platforms.",
    icon: "Smartphone",
    status: "active"
  },
  {
    id: 6,
    title: "App Development",
    description: "Native and cross-platform mobile applications that deliver exceptional user experiences across all devices.",
    icon: "Laptop",
    status: "active"
  },
  {
    id: 7,
    title: "Software Development",
    description: "Custom enterprise software solutions tailored to your unique business needs, streamlining operations and boosting efficiency.",
    icon: "Headphones",
    status: "active"
  },
  {
    id: 8,
    title: "IT Support",
    description: "24/7 technical support and IT infrastructure management to keep your business running without interruption.",
    icon: "Cloud",
    status: "active"
  },
  {
    id: 9,
    title: "Cloud Solutions",
    description: "Scalable cloud infrastructure and migration services to future-proof your business technology.",
    icon: "Server",
    status: "active"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Experienced Team",
    description: "Founded by professionals with years of industry experience working at leading tech companies.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Advanced Qualifications",
    description: "Team members hold multiple master's degrees and specialized certifications in their fields.",
    icon: "GraduationCap"
  },
  {
    id: 3,
    title: "Enterprise-Level Quality",
    description: "We bring big-company expertise to every project, regardless of size or budget.",
    icon: "CheckCircle"
  },
  {
    id: 4,
    title: "Personalized Service",
    description: "As a startup, you work directly with the founders. No middlemen, just dedicated attention.",
    icon: "Users"
  },
  {
    id: 5,
    title: "Transparent Pricing",
    description: "Clear, honest pricing with exceptional value. We're building our reputation, not padding profits.",
    icon: "DollarSign"
  },
  {
    id: 6,
    title: "Long-term Partnership",
    description: "We're invested in your success. Ongoing support ensures your digital presence evolves with your business.",
    icon: "LifeBuoy"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    company: "Elegant Interiors",
    role: "CEO",
    content: "Working with CRS Tech was refreshing. Their attention to detail and technical expertise is outstanding. They delivered exactly what we needed, on time and on budget.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop"
  },
  {
    id: 2,
    name: "Michael Chen",
    company: "Local Consulting Firm",
    role: "Founder",
    content: "Despite being a new company, CRS Tech's team brought years of professional experience. They understood our needs perfectly and created a website that truly represents our brand.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    company: "Wellness Hub",
    role: "Director",
    content: "The CRS Tech team is professional, responsive, and genuinely cares about delivering quality work. Their startup energy combined with industry experience is the perfect combination.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop"
  }
];

export const portfolio = [
  {
    id: 1,
    title: "E-Commerce Platform",
    category: "Web Development",
    description: "Full-featured online store with payment integration and inventory management",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop",
    tech: ["React", "Node.js", "MongoDB"]
  },
  {
    id: 2,
    title: "Corporate Website",
    category: "Web Design",
    description: "Professional corporate website with CMS and multi-language support",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=400&fit=crop",
    tech: ["WordPress", "PHP", "MySQL"]
  },
  {
    id: 3,
    title: "Restaurant Management",
    category: "Web Application",
    description: "Complete restaurant management system with online ordering",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&h=400&fit=crop",
    tech: ["Vue.js", "Express", "PostgreSQL"]
  }
];

export const pricingInfo = {
  regularPrice: 999,
  specialOfferPrice: 159,
  currency: "$",
  offerLimit: 10,
  paypalLink: "https://www.paypal.me/Crstechsolution/159",
  note: "Prices may vary depending on project scope, complexity, and specific requirements. Contact us for a personalized quote."
};

export const faqs = [
  {
    id: 1,
    question: "You're a startup - can I trust you with my project?",
    answer: "Absolutely! While CRS Tech is new, our team brings years of professional experience from leading tech companies. We've worked on enterprise-level projects and are now offering that same expertise directly to businesses like yours. Plus, you work directly with the founders - ensuring dedicated attention and accountability."
  },
  {
    id: 2,
    question: "How long does it take to build a website?",
    answer: "Typically, a standard business website takes 2-4 weeks from concept to launch. Complex projects with custom features may take 6-8 weeks. We'll provide you with a detailed timeline during our initial consultation and keep you updated throughout the process."
  },
  {
    id: 3,
    question: "Do you provide ongoing support after launch?",
    answer: "Yes! We offer 30 days of complimentary post-launch support. After that, we provide flexible maintenance packages including updates, security monitoring, backups, and SEO optimization. As a startup, we're building long-term relationships, not one-time transactions."
  },
  {
    id: 4,
    question: "Why are your prices so competitive?",
    answer: "As a new startup, we're building our portfolio and reputation. We're offering enterprise-level quality at startup-friendly prices. This special pricing won't last forever, so it's the perfect time to work with us and get exceptional value."
  },
  {
    id: 5,
    question: "What if I need changes after the website is launched?",
    answer: "We're here for you! Minor changes during the 30-day support period are complimentary. For larger updates or ongoing changes, we offer flexible maintenance plans that fit your needs and budget. We believe in growing together with our clients."
  }
];

// Mock chatbot responses
export const chatbotResponses = {
  greeting: [
    "Hello! Welcome to CRS Tech. I'm here to help you with any questions about our services.",
    "Hi there! Thanks for visiting CRS Tech. How can I assist you today?",
    "Welcome! I'm the CRS Tech assistant. What would you like to know?"
  ],
  services: "We offer a complete range of IT services including Website Design, Development, Hosting, Website Maintenance with SEO Management, Social Media Marketing, App Development, Software Development, IT Support, and Cloud Solutions. Would you like to know more about any specific service?",
  pricing: `Our regular starting price is $${pricingInfo.regularPrice}, but we have a special limited offer of just $${pricingInfo.specialOfferPrice} for the first ${pricingInfo.offerLimit} clients! This is an incredible opportunity to get premium website services at a fraction of the cost.`,
  contact: "You can reach us at crstech.com.au@gmail.com or call us at 0415365783. Would you like to schedule a consultation?",
  team: "Our expert team includes Premanshu Savalia (Founder & Front-end Developer) and Jay Khimusriya (Back-end Developer). Both team members have advanced degrees and extensive experience from working at leading companies.",
  seo: "Yes! Our Website Maintenance service includes comprehensive SEO management to improve your search rankings, increase organic traffic, and ensure your website stays optimized for search engines.",
  startup: "Yes, CRS Tech is a new startup, but our team brings years of professional experience from leading tech companies. We're offering enterprise-level expertise at startup-friendly prices!",
  complex: "This seems like a detailed question that requires personalized attention. Let me connect you with our team for a proper consultation.",
  default: "That's a great question! For detailed information, I'd recommend contacting our team directly. Would you like me to help you get in touch?"
};